import { Component, Signal } from '@angular/core';
import { select } from '@ngxs/store';
import { CodState } from '../../../cod/state/cod.state';

@Component({
    selector: 'app-stepper',
    standalone: true,
    templateUrl: './stepper.component.html'
})
export class StepperComponent {
    public step: Signal<number> = select(CodState.step);
}
